<form *ngIf="worksheetPageModel" (keydown.enter)="$event.preventDefault()" fusePerfectScrollbar [formGroup]="inputForm"
      class="flex flex-col full-grow-no-shrink-no-basis " >
  <ng-container>

    <div class="flex flex-col">
      <div class="flex flex-row">
        <mat-form-field appearance="outline" class="m-t-3">
          <mat-label>Questionnaire Name</mat-label>
          <input formControlName="questionnaireName" matInput placeholder="Questionnaire Name"/>
        </mat-form-field>
      </div>
      <div class="flex flex-row">
        <!--        <mat-form-field appearance="outline" class="m-r-20">-->
        <!--          <mat-label>Header Row</mat-label>-->
        <!--          <input  formControlName="headerRow"  matInput placeholder="Header Row"/>-->
        <!--        </mat-form-field>-->

        <mat-form-field appearance="outline" class="m-r-20">
          <mat-label>Header Row</mat-label>
          <mat-select formControlName="headerRow" required>
            <mat-option *ngFor="let item of totalRowArray" [value]="item">
              {{ item }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!--        <mat-form-field appearance="outline" class="m-r-20">-->
        <!--          <mat-label>Start Column</mat-label>-->
        <!--          <input  formControlName="startColumn"  matInput placeholder="Start Column"/>-->
        <!--        </mat-form-field>-->

        <mat-form-field appearance="outline" class="m-r-20">
          <mat-label>Start Column</mat-label>
          <mat-select formControlName="startColumn" required>
            <mat-option *ngFor="let item of worksheetPageModel.columns" [value]="item">
              {{ item.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="m-r-20">
          <mat-label>End Column</mat-label>
          <mat-select formControlName="endColumn" required>
            <mat-option *ngFor="let item of worksheetPageModel.columns" [value]="item">
              {{ item.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!--        <mat-form-field appearance="outline" class="m-r-20">-->
        <!--          <mat-label>End Column</mat-label>-->
        <!--          <input  formControlName="endColumn"  matInput placeholder="End Column"/>-->
        <!--        </mat-form-field>-->
      </div>

      <div class="flex flex-row">
        <!--          <mat-form-field appearance="outline" class="m-r-20">-->
        <!--            <mat-label>Start Data Row</mat-label>-->
        <!--            <input  formControlName="startDataRow"  matInput placeholder="Start Data Row"/>-->
        <!--          </mat-form-field>-->

        <mat-form-field appearance="outline" class="m-r-20">
          <mat-label>Start Data Row</mat-label>
          <mat-select formControlName="startDataRow" required>
            <mat-option *ngFor="let item of totalRowArray" [value]="item">
              {{ item }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="m-r-20">
          <mat-label>Start Data Row</mat-label>
          <mat-select formControlName="endDataRow" required>
            <mat-option *ngFor="let item of totalRowArray" [value]="item">
              {{ item }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!--          <mat-form-field appearance="outline" class="m-r-20">-->
        <!--            <mat-label>End Data Row</mat-label>-->
        <!--            <input  formControlName="endDataRow"  matInput placeholder="End Data Row"/>-->
        <!--          </mat-form-field>-->
      </div>
      <button mat-button class="action-button w-n-100 h-n-40 m-t-10" [disabled]="!isValid" (click)="apply()">
        Apply
      </button>
    </div>
  </ng-container>


  <!-- <div>
    <mat-list *ngIf = "headers && fieldDefinitions">
      <mat-list-item *ngFor="let header of headers; let i = index">
        <mat-checkbox [checked]="header.selected">
          <p>{{i + 1}} - {{header.name}}</p>
        </mat-checkbox>


        <mat-form-field>
          <mat-select [(value)]="header.dataType" placeholder="Select Data Type">
            <mat-option *ngFor="let field of fieldDefinitions" [value]="field.dataType">{{ field.dataType }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-slide-toggle [checked]="header.isPrimaryKey">Primary Key</mat-slide-toggle>

      </mat-list-item>
    </mat-list>



  </div> -->

  <ng-container>
    <div *ngIf="parameters" class="pos-relative">
      <div class="keno-grid-container ">
        <particle-virtual-grid-overlayfix
          [sourceKey]="sourceType"
          serviceName="ExcelTableDefinitionDynamicItemService"
          [invalidateSubject]="invalidateSubject"
          sortFieldKey="ColumnName"
          [parameters]="parameters"
          (valueChanged)="onGridCellValueChange($event)"
          (selectionChanged)="onSelectionChanged($event)"
          api="SpreadsheetApi"
          (fieldSectionChanged)="onFieldSectionChanged($event)"
          (selectionChanged)="onSelectionChange($event)"
          (selectionAllChanged)="onSelectionAllChanged($event)"
        >
        </particle-virtual-grid-overlayfix>
      </div>
    </div>
  </ng-container>
</form>


